import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CompanyPageComponent } from "./company-page/company-page.component";
import { Routes, RouterModule } from "@angular/router";
import { AnalystModelsComponent } from "./analyst-models/analyst-models.component";
import { IconsModule } from "@va/core-library/icons";

import { CompanyResearchComponent } from "./company-research/company-research.component";
import { CompanyTearSheetComponent } from "./company-tear-sheet/company-tear-sheet.component";
import { SharedModule } from "../shared/shared.module";
import { DataCellRenderersModule } from "../data-cell-renderers/data-cell-renderers.module";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { ChartPlotterModule } from "../chart-plotter/chart-plotter.module";
import { FormsModule } from "@angular/forms";
import { CompanyStatusComponent } from "./company-status/company-status.component";
import { CompanyEarningsPreviewComponent } from "./company-earnings-preview/company-earnings-preview.component";
import { NormalizeForecastComponent } from "./normalize-forecast/normalize-forecast.component";
import { RouteGuardService } from "./route-guard.service";
import { ResourceDownloadComponent } from "./resource-download/resource-download.component";
import { LineItemMonitorModule } from "../line-item-monitor/line-item-monitor.module";
import { PreviewListModule } from "@va/core-library/preview-list";
import { NzSkeletonModule } from "ng-zorro-antd/skeleton";
import { NzTableModule } from "ng-zorro-antd/table";
import { NzModalModule } from "ng-zorro-antd/modal";
import { NzTagModule } from "ng-zorro-antd/tag";
import { NzGridModule } from "ng-zorro-antd/grid";
import { NzPopoverModule } from "ng-zorro-antd/popover";
import { NzListModule } from "ng-zorro-antd/list";
import { NzToolTipModule } from "ng-zorro-antd/tooltip";
import { NzDropDownModule } from "ng-zorro-antd/dropdown";
import { NzSelectModule } from "ng-zorro-antd/select";

import { ButtonModule } from "@va/core-library/button";

//pipe
import { SafePipeModule } from "src/app/pipes/safe.pipe.module";

const companyRoutes: Routes = [
  {
    path: ":ticker/download/:downloadType/:param1/:param2/:param3",
    component: ResourceDownloadComponent,
    data: {
      title: "Company Home",
    },
  },
  {
    path: ":ticker",
    component: CompanyPageComponent,
    data: {
      title: "Company Home",
    },
  },
  {
    path: ":ticker/",
    component: CompanyPageComponent,
    data: {
      title: "Company Home",
    },
  },
  {
    path: ":ticker/monitor",
    redirectTo: ":ticker",
  },
  {
    path: ":ticker/surprise",
    loadChildren: () =>
      import("../surprise-page/surprise-page.module").then(
        (mod) => mod.SurprisePageModule,
      ),
  },
  {
    path: ":ticker/vsconsensus",
    loadChildren: () =>
      import("../vsconsensus-page/vsconsensus-page.module").then(
        (mod) => mod.VSConsensusPageModule,
      ),
  },
  {
    path: ":ticker/revisions/:tickerType",
    loadChildren: () =>
      import("../revision-page/revision-page.module").then(
        (mod) => mod.RevisionPageModule,
      ),
    canActivate: [RouteGuardService],
  },
  {
    path: ":ticker/revisions",
    loadChildren: () =>
      import("../revision-page/revision-page.module").then(
        (mod) => mod.RevisionPageModule,
      ),
  },
  {
    path: ":ticker/analystdashboard",
    loadChildren: () =>
      import("../qc-dashboard-page/qc-dashboard-page.module").then(
        (mod) => mod.QcDashboardPageModule,
      ),
  },
  {
    path: ":ticker/events",
    loadChildren: () =>
      import("../events-page/events-page.module").then(
        (mod) => mod.EventsPageModule,
      ),
    canActivate: [RouteGuardService],
  },
  {
    path: ":ticker/valuation",
    loadChildren: () =>
      import("../valuation-page/valuation-page.module").then(
        (mod) => mod.ValuationPageModule,
      ),
  },
  {
    path: ":ticker/tpr",
    pathMatch: "full",
    loadChildren: () =>
      import("../tpr/tpr.module").then((mod) => mod.TprModule),
  },
  {
    path: ":ticker/nav",
    loadChildren: () =>
      import("../company-nav-page/company-nav-page.module").then(
        (mod) => mod.CompanyNavPageModule,
      ),
  },
  {
    path: "**",
    redirectTo: "/home",
  },
];

@NgModule({
  imports: [RouterModule.forChild(companyRoutes)],
  exports: [RouterModule],
})
export class CompanyRoutingModule {}

@NgModule({
  declarations: [
    CompanyPageComponent,
    CompanyTearSheetComponent,
    CompanyResearchComponent,
    AnalystModelsComponent,
    CompanyStatusComponent,
    CompanyEarningsPreviewComponent,
    ResourceDownloadComponent,
    NormalizeForecastComponent,
  ],
  bootstrap: [CompanyEarningsPreviewComponent],
  imports: [
    CommonModule,
    CompanyRoutingModule,
    NzSkeletonModule,
    IconsModule,
    SharedModule,
    DataCellRenderersModule,
    InfiniteScrollModule,
    ChartPlotterModule,
    LineItemMonitorModule,
    SharedModule,
    FormsModule,
    PreviewListModule,
    NzTableModule,
    NzModalModule,
    NzTagModule,
    NzGridModule,
    NzPopoverModule,
    NzListModule,
    NzToolTipModule,
    NzDropDownModule,
    NzSelectModule,
    ButtonModule,
    SafePipeModule,
  ],
})
export class CompanyPageModule {}
